import styles from './Alert.module.css';

function Alert({ children, type = 'info', className = '' }) {
    const alertClass = `${styles.alert} ${styles[type] || styles.info} ${className}`.trim();

    return (
        <div className={alertClass}>
            {children}
        </div>
    );
}

export default Alert;
